<template>
  <div class="alert_container" v-if="show">
    <div class="alert_overlay"></div>
    <div class="alert_content">
      <p>
        {{ $t("departmentIdAlert") }}
      </p>
      <div class="action_container">
        <v-btn text dark @click="close">{{ $t("gotIt") }}</v-btn>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DepartmentAlert",
  data() {
    return {
      show: false,
      userValue: this.user,
    };
  },
  methods: {
    close() {
      this.show = false;
    },
  },
  computed: {
    user() {
      return this.$store.state.user.user;
    },
  },
  watch: {
    user(newUser) {
      this.show = newUser && !newUser.department_id;
    },
  },
};
</script>

<style>
.alert_container {
  position: fixed;
  right: 50px;
  bottom: 20px;
  border-radius: 4px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
  padding: 12px;
  max-width: 576px;
  color: #fff;
  background-color: #ef2525;
  text-align: left;
  z-index: 4;
}
</style>
